export enum LessonStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface LessonDetails {
  id: string;
  title: string;
  description: string;
  createdAt: string;
  duration: number;
  videoUrl: string;
  imageKey: string;
  sectionId: string;
  status: string;
  visibility: string;
  order: number;
  course: {
    id: string;
    title: string;
  };
  statistics?: {
    totalUsers: number;
    finishedUsers: number;
    inProgressUsers: number;
  };
  userStatus?: {
    status: LessonStatus;
  };
}
